"use strict";

(function () {
  const BUTTON_SELECTOR = '.bls__product-item .bls__product-wishlist-js';
  const ACTIVE_CLASS = 'origin-wishlist-active';
  const STORAGE_KEY = 'bls__wishlist-items';

  function isWishlistPage(button) {
    return !!button.closest('.bls__wishlist-page-main, .bls__wishlist-page-section');
  }

  function getStoredItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function isStoredActive(button) {
    const handle = button.dataset.productHandle;
    return !!handle && getStoredItems().includes(handle);
  }

  function setVisualState(button, active) {
    button.classList.toggle(ACTIVE_CLASS, active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncNativeIcon(button, active) {
    const icon = button.querySelector('.bls__product-icon');
    if (icon) {
      icon.classList.toggle('active', active);
    }
  }

  function syncButton(button) {
    if (!button || isWishlistPage(button)) return;

    const active = isStoredActive(button);
    setVisualState(button, active);
    syncNativeIcon(button, active);
  }

  function syncAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(BUTTON_SELECTOR).forEach(syncButton);
  }

  function findButton(target) {
    return target instanceof Element ? target.closest(BUTTON_SELECTOR) : null;
  }

  function showOptimisticToggle(button) {
    if (!button || isWishlistPage(button)) return;

    /* Do not touch the theme's native .active class before its click handler runs. */
    setVisualState(button, !isStoredActive(button));
  }

  function reconcile(button) {
    [80, 220, 500].forEach(function (delay) {
      window.setTimeout(function () {
        syncButton(button);
      }, delay);
    });
  }

  function boot() {
    syncAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Instant visual feedback. The stored wishlist remains the only source of truth. */
  document.addEventListener('pointerdown', function (event) {
    showOptimisticToggle(findButton(event.target));
  }, true);

  /* Keyboard activation gets the same instant feedback, then reconciles with Shopify's native handler. */
  document.addEventListener('click', function (event) {
    const button = findButton(event.target);
    if (!button || isWishlistPage(button)) return;

    if (event.detail === 0) {
      showOptimisticToggle(button);
    }

    reconcile(button);
  }, true);

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      syncAll(document);
    }
  });

  /* Newly rendered cards must reflect the real wishlist, never a stale native class. */
  const observer = new MutationObserver(function (records) {
    let addedContent = false;

    records.forEach(function (record) {
      if (record.type === 'childList' && record.addedNodes.length) {
        addedContent = true;
      }
    });

    if (addedContent) {
      requestAnimationFrame(function () {
        syncAll(document);
      });
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true
  });

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });
})();
